import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { isObservable, map, switchMap, of } from 'rxjs';
import { WELLS_NPT_ENABLED, WellsContextService } from '../services/wells-context.service';
import { wellsSupplierIsolationGuard } from './wells-supplier.guard';

export const wellsMembershipFeatureGuard: CanMatchFn = () => inject(WELLS_NPT_ENABLED) ? wellsSupplierIsolationGuard() : inject(Router).parseUrl('/access-denied');

export const wellsNptGuard: CanMatchFn = () => {
  const context = inject(WellsContextService);
  const router = inject(Router);
  const enter = () => context.refresh().pipe(map(allowed => allowed && context.enterWells() ? true : router.parseUrl('/access-denied')));
  if (!inject(WELLS_NPT_ENABLED)) return enter();
  if (!context.principal()) return true;
  const isolation = wellsSupplierIsolationGuard();
  return (isObservable(isolation) ? isolation : of(isolation)).pipe(
    switchMap(result => result === true ? enter() : of(result)));
};

export const legacyContextGuard: CanMatchFn = (route) => {
  const context = inject(WellsContextService);
  const router = inject(Router);
  const destination = () => context.active() ? router.parseUrl(route.path === 'dashboard' ? '/wells-npt/dashboard' : '/wells-npt') : true;
  if (!inject(WELLS_NPT_ENABLED)) return destination();
  const isolation = wellsSupplierIsolationGuard();
  return (isObservable(isolation) ? isolation : of(isolation)).pipe(
    map(result => result === true ? destination() : result));
};